import _classCallCheck from "C:\\Users\\Kristaps\\projects\\proj261\\site\\node_modules\\@babel\\runtime\\helpers\\esm\\classCallCheck.js";
import _createClass from "C:\\Users\\Kristaps\\projects\\proj261\\site\\node_modules\\@babel\\runtime\\helpers\\esm\\createClass.js";
import _inherits from "C:\\Users\\Kristaps\\projects\\proj261\\site\\node_modules\\@babel\\runtime\\helpers\\esm\\inherits.js";
import _possibleConstructorReturn from "C:\\Users\\Kristaps\\projects\\proj261\\site\\node_modules\\@babel\\runtime\\helpers\\esm\\possibleConstructorReturn.js";
import _getPrototypeOf from "C:\\Users\\Kristaps\\projects\\proj261\\site\\node_modules\\@babel\\runtime\\helpers\\esm\\getPrototypeOf.js";
import _defineProperty from "C:\\Users\\Kristaps\\projects\\proj261\\site\\node_modules\\@babel\\runtime\\helpers\\esm\\defineProperty.js";

var _transitionClasses;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import cn from 'classnames';
import css from 'dom-helpers/css';
import _getHeight from 'dom-helpers/height';
import transitionEnd from 'dom-helpers/transitionEnd';
import React from 'react';
import Transition, { ENTERING, EXITED, EXITING } from 'react-transition-group/Transition';
var transitionClasses = (_transitionClasses = {}, _defineProperty(_transitionClasses, ENTERING, 'rw-slide-transition-entering'), _defineProperty(_transitionClasses, EXITING, 'rw-slide-transition-exiting'), _defineProperty(_transitionClasses, EXITED, 'rw-slide-transition-exited'), _transitionClasses);

var SlideDownTransition = /*#__PURE__*/function (_React$Component) {
  _inherits(SlideDownTransition, _React$Component);

  var _super = _createSuper(SlideDownTransition);

  function SlideDownTransition() {
    var _this;

    _classCallCheck(this, SlideDownTransition);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.setContainerHeight = function (elem) {
      elem.style.height = _this.getHeight(elem) + 'px';
    };

    _this.clearContainerHeight = function (elem) {
      elem.style.height = '';
    };

    _this.handleEntered = function (elem) {
      _this.clearContainerHeight(elem);

      if (_this.props.onEntered) _this.props.onEntered();
    };

    _this.handleEntering = function () {
      if (_this.props.onEntering) _this.props.onEntering();
    };

    _this.handleExit = function (elem) {
      _this.setContainerHeight(elem);

      if (_this.props.onExit) _this.props.onExit();
    };

    _this.handleExited = function (elem) {
      _this.clearContainerHeight(elem);

      if (_this.props.onExited) _this.props.onExited();
    };

    _this.handleTransitionEnd = function (el, done) {
      transitionEnd(el.firstChild, done);
    };

    return _this;
  }

  _createClass(SlideDownTransition, [{
    key: "getHeight",
    value: function getHeight(container) {
      var content = container.firstChild;
      var margin = parseInt(css(content, 'margin-top'), 10) + parseInt(css(content, 'margin-bottom'), 10);
      var old = container.style.display;
      var height;
      container.style.display = 'block';
      height = (_getHeight(content) || 0) + (isNaN(margin) ? 0 : margin);
      container.style.display = old;
      return height;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          dropUp = _this$props.dropUp;
      return /*#__PURE__*/React.createElement(Transition, {
        appear: true,
        in: this.props.in,
        onEnter: this.setContainerHeight,
        onEntering: this.handleEntering,
        onEntered: this.handleEntered,
        onExit: this.handleExit,
        onExited: this.handleExited,
        addEndListener: this.handleTransitionEnd,
        timeout: undefined
        /*hack*/

      }, function (status, innerProps) {
        return /*#__PURE__*/React.createElement("div", _extends({}, innerProps, {
          className: cn(className, dropUp && 'rw-dropup', transitionClasses[status])
        }), /*#__PURE__*/React.cloneElement(children, {
          className: cn('rw-slide-transition', children.props.className)
        }));
      });
    }
  }]);

  return SlideDownTransition;
}(React.Component);

export default SlideDownTransition;